module.exports = __webpack_public_path__ + "img/metal.10ea6911.png";